import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { Button } from "./ui/button";
import { navLinks, whatsappLink } from "../mock";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm py-2" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#inicio" className="shrink-0">
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-[#2f3a45] hover:text-[#b89a5a] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-[#b89a5a] hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            asChild
            className="bg-[#b89a5a] hover:bg-[#a5884b] text-white rounded-full px-6 shadow-md hover:shadow-lg transition-all"
          >
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
              <Phone className="w-4 h-4 mr-2" /> Agendar Consulta
            </a>
          </Button>
        </div>

        <button
          className="lg:hidden text-[#2f3a45]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#e8eaed] shadow-lg">
          <nav className="flex flex-col px-6 py-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-3 text-[#2f3a45] font-medium border-b border-[#e8eaed] last:border-0"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              className="mt-4 bg-[#b89a5a] hover:bg-[#a5884b] text-white rounded-full"
            >
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                <Phone className="w-4 h-4 mr-2" /> Agendar Consulta
              </a>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
